import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store/types";

// Root selectors
const getClosureMsgState = (state: RootState) => state.closureMsg;

export const getClosureMsgDataSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.closureMsgData,
);

export const getClosureMsgMediaFileInfoSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.closureMsgMediaFileInfo,
);

export const getClosureMsgStatusSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.closureMsgStatus,
);

export const getClosureMsgMediaFileStatusSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.closureMsgMediaFileStatus,
);

export const getClosureMsgPendingSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.isCMPending,
);
export const getClosureMsgSaveSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.isCMSave,
);
export const getClosureMsgDeleteSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.isCMDelete,
);

export const getClosureMsgErrorSelector = createSelector(
  [getClosureMsgState],
  (closureMsg) => closureMsg?.isCMError,
);
